import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { SessionBootstrapService } from './services/session-bootstrap.service';
import { HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, finalize, Observable, switchMap, throwError } from 'rxjs';
export const AuthInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);
  const sessionBootstrap = inject(SessionBootstrapService);

  const excludedLoaderUrls = ['/api/Proxy?path=%2Fapi%2FUserMaster%2FGetAllProducts','/api/Proxy?path=%2Fapi%2FClearance%2FStates','api%2FUserMaster%2FUpdateLastActivitySession'];
  const shouldExcludeLoader = excludedLoaderUrls.some((url) => req.url.includes(url));
  const isCacheGet = isSessionCacheGetRequest(req.url);

  if (!shouldExcludeLoader && (isCacheGet || !sessionBootstrap.isActive())) {
    if (isCacheGet) {
      authService.beginCacheApiLoading();
    } else {
      authService.setLoading(true);
    }
  }

  const token = authService.getToken(); 
  const refreshToken = authService.getRefreshToken();
  const excludedUrls = ['/forgot-password', '/reset-password','/login','/api/Proxy?path=%2Fapi%2FHome%2Flogin'];
  const excludeTokenParamUrl = '/api/PropertyData/BasIcInfo'; // URL where token should not be added
  
  const isExcluded = excludedUrls.some((url) => req.url.includes(url));
  const shouldExcludeTokenParam = req.url.includes(excludeTokenParamUrl); // Check if the URL requires token exclusion
  
  let clonedRequest = req;
  
  if (!isExcluded && token) {
    clonedRequest = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`, 
      },
      // setParams: shouldExcludeTokenParam
      //   ? {} // Do not add 'token' param
      //   : { token: token } // Add 'token' param //reverttoken changes
    });
  }
  
  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && refreshToken && !req.url.includes('/Home/Logout')) {
        // Token refresh logic
        return authService.getNewToken(String(token), refreshToken).pipe(
          switchMap((newToken: { jwtToken: string; refreshToken: string }) => {
            // Save new tokens
            authService.setToken(newToken.jwtToken);
            authService.setRefreshToken(newToken.refreshToken);
  
            // Retry the original request with the new token
            const retryRequest = req.clone({
              setHeaders: {
                Authorization: `Bearer ${newToken.jwtToken}`,
              },
              // setParams: shouldExcludeTokenParam
              //   ? {} // Do not add 'token' param
              //   : { token: newToken.jwtToken } // Add 'token' param
            });
  
            return next(retryRequest);
          }),
          catchError((refreshError) => {
            // Logout user if refresh fails
            const { userId } = authService.getUserDetailsFromStorage()?.userDetails || {};
            authService.logout(String(token), Number(userId), false);
            return throwError(() => refreshError);
          })
        );
      }
      return throwError(() => error);
    }),
    finalize(() => {
      if (isCacheGet) {
        authService.endCacheApiLoading();
      } else if (!sessionBootstrap.isActive()) {
        authService.setLoading(false);
      }
    })
  );
}

function isSessionCacheGetRequest(url: string): boolean {
  if (url.includes('%2Fapi%2Fcache%2Fget') || url.includes('/api/cache/get')) {
    return true;
  }
  try {
    const decoded = decodeURIComponent(url);
    return /\/api\/cache\/get\b/i.test(decoded);
  } catch {
    return false;
  }
}